@if (showBox) {
  <div class="message-box col-12 col-md-12 col-lg-6 col-lg-6" [ngClass]="success ? 'message-box-success' : 'message-box-failure'" [@fadeOut]="state">
    <div class="message-img col-1 img-fluid" [ngClass]="success ? 'message-img-success' : 'message-img-failure'"></div>
    <div class="message-text">
      <span>{{ messages[0] }}</span
        ><br />
        <span>{{ messages[1] }}</span>
      </div>
    </div>
  }
